// API URL Configuration
// Can be overridden with REACT_APP_API_URL environment variable
// Default: Production API
const API_BASE_URL = process.env.REACT_APP_API_URL ||"https://api.theskillgenie.com";

export default API_BASE_URL;



